import React, { useState, useEffect, useRef } from "react";
import { Link } from 'react-router-dom';
import { ROUTE_BASE_URL, baseUrl } from '../../api/common';
import { showToast, ToastMessage } from "../Shared/ToastMessage";
import axios from "axios";
import Loader from "../common/Loader";
import { useUser } from "../AdminUsers/UserContext";
import ReactPhoneInput from "react-phone-number-input";

const Settings = () => {

 const { checkPermission } = useUser();
 const {fetchSettingsDetails} = useUser();

  //----------------- Profile ----------------

  const [commonLogo, setCommonLogo] = useState("../../assets/images/user_image.png");
  const [logo, setLogo] = useState(null);
  const fileInputRef = useRef(null);

  const handleImageClick = () => {
    fileInputRef.current.click();
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const imageUrl = URL.createObjectURL(file);
      setLogo(imageUrl);
      formValues.logo = file;
    }
  };

  //-------------------------------------------------

  const [formValues, setFormValues] = useState({
    website_name: "",
    email: "",
    phone: "",
    logo: "",
    razor_key_id:"",
    razor_key_secret:"",
    webaddress:"",
    webgst:"",
    place_of_supply:"",
    smtp_email:"",
    smtp_password:""
  });

  const [errors, setErrors] = useState({
    website_name: "",
    email: "",
    phone: "",
    logo: "",
    razor_key_id:"",
    razor_key_secret:"",
    webaddress:"",
    webgst:"",
    place_of_supply:"",
    smtp_email:"",
    smtp_password:""
  });

  const handleInputChange = (field, value) => {
    setFormValues({ ...formValues, [field]: value });
  };

  const validate = () => {
    const newErrors = {
      website_name: "",
      email: "",
      phone: "",
      logo: "",
      razor_key_id:"",
      razor_key_secret:"",
      webaddress:"",
      webgst:"",
      place_of_supply:"",
      smtp_email:"",
      smtp_password:""
    };
    if(!logo && (settingsDetails.logo === null || settingsDetails.logo === "" || settingsDetails.logo === undefined)){
      newErrors.logo = 'Logo cannot be empty';
    }
    if (!formValues.website_name.trim()) {
      newErrors.website_name = 'Website name cannot be empty';
    }
    if (!formValues.email.trim()) {
      newErrors.email = 'Email cannot be empty';
    } else if (!(/^\S+@\S+\.\S+$/.test(formValues.email.trim()))) {
      newErrors.email = 'Invalid email format';
    }
    if (!formValues.phone) {
      newErrors.phone = 'Phone number cannot be empty';
    }
    if (!formValues.razor_key_id) {
      newErrors.razor_key_id = 'Razorpay key id cannot be empty';
    }
    if (!formValues.razor_key_secret) {
      newErrors.razor_key_secret = 'Razorpay secret key cannot be empty';
    }
    if (!formValues.webaddress) {
      newErrors.webaddress = 'Address cannot be empty';
    }
    if (!formValues.webgst) {
      newErrors.webgst = 'GST cannot be empty';
    }
    if (!formValues.place_of_supply) {
      newErrors.place_of_supply = 'Place of supply cannot be empty';
    }
    if (!formValues.smtp_email) {
      newErrors.smtp_email = 'SMTP email cannot be empty';
    }
    if (!formValues.smtp_password) {
      newErrors.smtp_password = 'SMTP password cannot be empty';
    }
    setErrors(newErrors);
    return Object.values(newErrors).every((error) => error === '');
  };

  const clearInputValues = () => {
    setErrors({
      website_name: "",
      email: "",
      phone: "",
      logo: "",
      razor_key_id:"",
      razor_key_secret:"",
      webaddress:"",
      webgst:"",
      place_of_supply:"",
      smtp_email:"",
      smtp_password:""
    });
    setFormValues({
      website_name: "",
      email: "",
      phone: "",
      logo: "",
      razor_key_id:"",
      razor_key_secret:"",
      webaddress:"",
      webgst:"",
      place_of_supply:"",
      smtp_email:"",
      smtp_password:""
    });
  };

  const [settingsDetails, setMyProfileDetails] = useState({});

  const fetchSettingsData = async () => {
    try {
      const response = await axios.get(`${baseUrl}/api/settings`,{
        headers: {
          "Content-Type": "application/json",
          Authorization: localStorage.getItem("access_token"),
        },
      });

      if (response.data.status) {
        const details = response.data.data[0];
        setMyProfileDetails(details);
        setFormValues({
          website_name: details.website_name,
          email: details.email,
          phone: details.phone,
          logo: "",
          razor_key_id:details.razor_key_id,
          razor_key_secret:details.razor_key_secret,
          webaddress:details.webaddress,
          webgst:details.webgst,
          place_of_supply:details.place_of_supply,
          smtp_email:details.smtp_email,
          smtp_password:details.smtp_password,
        });
        // localStorage.setItem('loginUserName', details.full_name);
        if (details.logo !== null && details.logo !== "" && details.logo !== undefined) {
          setCommonLogo(`${baseUrl}/${details.logo}`);
          // localStorage.setItem('loginUserImage', details.profile);
        }
      } else {
        console.error("Error: Failed to fetch user data");
      }
    } catch (error) {
      console.error("Error fetching users data:", error);
    }
  };

  const updateSettings = async () => {
    const hasPermission = await checkPermission("Settings", "update");
    if (!hasPermission) return;
    if (validate()) {
      console.log('Post Data:', formValues);
      try {
        const requestData = {
          ...formValues,
          ...{ id: settingsDetails.id }
        };
        console.log("Update requestData Data:", requestData);
        const response = await axios.post(
          `${baseUrl}/api/settings_update`,
          requestData,
          {
            headers: {
              "Content-Type": "multipart/form-data",
              Authorization: localStorage.getItem('access_token'),
            },
          }
        );
        if (response.data.status) {
          showToast(response.data.message, 'success');
          fetchSettingsData();
          fetchSettingsDetails();
          clearInputValues();
        } else {
          showToast(response.data.message, 'error');
        }
      } catch (error) {
        console.error("Error during submission:", error);
        showToast("Submission failed. Please try again.", "error");
      }
    }
  };

  const handleMobileChange = (value) => {
    setFormValues({
      ...formValues,
      phone: value,
    });
  };
  // Check Admin User Permission
  const [checkUserLoading, setCheckUserLoading] = useState(false); 
  const fetchPermission = async () => {
    setCheckUserLoading(true);
    try {
      const hasPermission = await checkPermission("Settings", "view");
      if (!hasPermission) return;
    } catch (error) {
      console.error("Error fetching super specialty data:", error);
    }finally{
      setCheckUserLoading(false);
    }
  };
  useEffect(() => {
    fetchPermission();
  }, []);

  useEffect(() => {
    fetchSettingsData();
  }, []);

  return (
    <>
      <ToastMessage />
      {(settingsDetails && !checkUserLoading)?
        <div className="container-fluid">
          <div className="block-header">
            <div className="row clearfix">
              <div className="col-md-6 col-sm-12">
                <h2>Website Settings</h2>
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to={`${ROUTE_BASE_URL}/`}>AMASI</Link></li>
                    <li className="breadcrumb-item active" aria-current="page">Website Settings</li>
                  </ol>
                </nav>
              </div>
            </div>
          </div>
          <div className="row clearfix">
            <div className="col-xl-12 col-lg-12 col-md-12">
              <div className="card">
                <div className="body">
                  <div className="row clearfix">
                    <div className="col-lg-12 col-md-12 pos_relative">
                      <label>
                        Upload Logo
                      </label>
                      <p style={{ margin: "0" }} />
                      <div className="pos_re">
                        <img src={logo||commonLogo}
                          width="80"
                          height="80"
                          className="img-thumbnail rounded-circle width_profile_image"
                          alt="person"
                          onClick={handleImageClick}
                          style={{ cursor: "pointer" }} />
                        <i onClick={handleImageClick} className="fa fa-pencil upload_image_edit_icon" />
                        <input
                          type="file"
                          ref={fileInputRef}
                          style={{ display: "none" }}
                          accept="image/*"
                          onChange={handleFileChange}
                        />
                      </div>
                      {errors && (
                        <p className="text-danger pos_abos">
                          {errors.logo}
                        </p>
                      )}
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <label>
                        Name <span className="text-danger">*</span>
                      </label>
                      <div className="form-group pos_relative">
                        <input
                          type="text"
                          className={`form-control ${errors.website_name ? "red_border" : ""
                            }`}
                          value={formValues.website_name}
                          onChange={(e) => {
                            let input = e.target.value;
                            // input = input.replace(/[^A-Za-z]/g, "");
                            handleInputChange("website_name", input);
                          }}
                        />
                        {errors && (
                          <p className="text-danger pos_abos">
                            {errors.website_name}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <label>
                        Email <span className="text-danger">*</span>
                      </label>
                      <div className="form-group pos_relative">
                        <input
                          type="email"
                          className={`form-control ${errors.email ? "red_border" : ""
                            }`}
                          value={formValues.email}
                          onChange={(e) => {
                            let input = e.target.value;
                            // input = input.replace(/[^A-Za-z]/g, "");
                            handleInputChange("email", input);
                          }}
                        />
                        {errors && (
                          <p className="text-danger pos_abos">
                            {errors.email}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <label>
                        Phone <span className="text-danger">*</span>
                      </label>
                      <div className="form-group pos_relative">
                         <ReactPhoneInput
                            defaultCountry={"IN"}
                            value={formValues.phone}
                            onChange={handleMobileChange}
                            // international
                            withCountryCallingCode
                            className={`custom-phone-input form-control ${errors.phone ? "red_border" : ""
                              }`}
                            placeholder="Enter your Phone number"
                          />
                        {/* <input
                          type="number"
                          className={`form-control ${errors.phone ? "red_border" : ""
                            }`}
                          value={formValues.phone}
                          onChange={(e) => {
                            let input = e.target.value;
                            // input = input.replace(/[^A-Za-z]/g, "");
                            handleInputChange("phone", input);
                          }}
                        /> */}
                        {errors && (
                          <p className="text-danger pos_abos">
                            {errors.phone}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <label>
                        Razorpay Key ID <span className="text-danger">*</span>
                      </label>
                      <div className="form-group pos_relative">
                        <input
                          type="text"
                          className={`form-control ${errors.razor_key_id ? "red_border" : ""
                            }`}
                          value={formValues.razor_key_id}
                          onChange={(e) => {
                            let input = e.target.value;
                            // input = input.replace(/[^A-Za-z]/g, "");
                            handleInputChange("razor_key_id", input);
                          }}
                        />
                        {errors && (
                          <p className="text-danger pos_abos">
                            {errors.razor_key_id}
                          </p>
                        )}
                      </div>
                    </div>
                    {/* <div className="col-lg-6 col-md-12">
                      <label>
                        Address <span className="text-danger">*</span>
                      </label>
                      <div className="form-group pos_relative">
                        <textarea
                          rows={4}
                          type="text"
                          className={`form-control ${errors.address ? 'red_border' : ''}`}
                          value={formValues.address}
                          onChange={e =>
                            handleInputChange('address', e.target.value)}
                        />
                        {errors && (
                          <p className="text-danger pos_abos">
                            {errors.address}
                          </p>
                        )}
                      </div>
                    </div> */}
                    <div className="col-lg-6 col-md-12">
                      <label>
                        Razorpay Secret Key <span className="text-danger">*</span>
                      </label>
                      <div className="form-group pos_relative">
                        <input
                          type="text"
                          className={`form-control ${errors.razor_key_secret ? "red_border" : ""
                            }`}
                          value={formValues.razor_key_secret}
                          onChange={(e) => {
                            let input = e.target.value;
                            // input = input.replace(/[^A-Za-z]/g, "");
                            handleInputChange("razor_key_secret", input);
                          }}
                        />
                        {errors && (
                          <p className="text-danger pos_abos">
                            {errors.razor_key_secret}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <label>
                        GST Number <span className="text-danger">*</span>
                      </label>
                      <div className="form-group pos_relative">
                        <input
                          type="text"
                          className={`form-control ${errors.webgst ? "red_border" : ""
                            }`}
                          value={formValues.webgst}
                          onChange={(e) => {
                            let input = e.target.value;
                            handleInputChange("webgst", input);
                          }}
                        />
                        {errors && (
                          <p className="text-danger pos_abos">
                            {errors.webgst}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <label>
                        Address <span className="text-danger">*</span>
                      </label>
                      <div className="form-group pos_relative">
                        <textarea
                          rows={4}
                          type="text"
                          className={`form-control ${errors.webaddress ? 'red_border' : ''}`}
                          value={formValues.webaddress}
                          onChange={e =>
                            handleInputChange('webaddress', e.target.value)}
                        />
                        {errors && (
                          <p className="text-danger pos_abos">
                            {errors.webaddress}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <label>
                       Place of Supply <span className="text-danger">*</span>
                      </label>
                      <div className="form-group pos_relative">
                        <input
                          type="text"
                          className={`form-control ${errors.place_of_supply ? "red_border" : ""
                            }`}
                          value={formValues.place_of_supply}
                          onChange={(e) => {
                            let input = e.target.value;
                            handleInputChange("place_of_supply", input);
                          }}
                        />
                        {errors && (
                          <p className="text-danger pos_abos">
                            {errors.place_of_supply}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <label>
                        SMTP Email <span className="text-danger">*</span>
                      </label>
                      <div className="form-group pos_relative">
                        <input
                          type="text"
                          className={`form-control ${errors.smtp_email ? "red_border" : ""
                            }`}
                          value={formValues.smtp_email}
                          onChange={(e) => {
                            let input = e.target.value;
                            handleInputChange("smtp_email", input);
                          }}
                        />
                        {errors && (
                          <p className="text-danger pos_abos">
                            {errors.smtp_email}
                          </p>
                        )}
                      </div>
                    </div>
                    <div className="col-lg-6 col-md-12">
                      <label>
                        SMTP Password <span className="text-danger">*</span>
                      </label>
                      <div className="form-group pos_relative">
                        <input
                          type="text"
                          className={`form-control ${errors.smtp_password ? "red_border" : ""
                            }`}
                          value={formValues.smtp_password}
                          onChange={(e) => {
                            let input = e.target.value;
                            handleInputChange("smtp_password", input);
                          }}
                        />
                        {errors && (
                          <p className="text-danger pos_abos">
                            {errors.smtp_password}
                          </p>
                        )}
                      </div>
                    </div>
                  </div>
                  <button onClick={updateSettings} type="button" className="btn btn-outline-info mr-1">Update</button> &nbsp;&nbsp;
                  {/* <button type="button" className="btn btn-round btn-default">Cancel</button> */}
                </div>
              </div>
            </div>
          </div>
        </div> : <Loader />
      }
    </>
  );

}
export default Settings
